import React from 'react';

const NotificationCard = React.memo(({ notification, onClick }) => {
  const formatTimeSinceCreated = (createdAt) => {
    const createdDate = new Date(createdAt);
    const nowMoscow = new Date();
    nowMoscow.setHours(nowMoscow.getHours() + 3); // Конвертируем в московское время (UTC+3)

    const diffMs = nowMoscow - createdDate;
    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);
    
    // Если больше месяца (примерно 30 дней)
    if (diffDays >= 30) {
      const diffMonths = Math.floor(diffDays / 30);
      return `${diffMonths} мес. назад`;
    }
    
    // Если больше дня (24 часа)
    if (diffDays >= 1) {
      return `${diffDays} дн. назад`;
    }
    
    // Если больше часа
    if (diffHours >= 1) {
      return `${diffHours} ч. назад`;
    }
    
    // Если больше минуты
    if (diffMinutes >= 1) {
      return `${diffMinutes} мин. назад`;
    }
    
    // Если меньше минуты
    return 'только что';
  };

  const getStatusText = (status) => {
    if (status === 'wait') return 'Ожидает';
    if (status === 'success') return 'Одобрено';
    if (status === 'reject') return 'Отклонено';
    return 'Неизвестный статус';
  };

  return (
    <div 
      className={`notification-card ${notification.status === 'wait' ? 'notification-card-wait' : ''}`}
      onClick={onClick}
    >
      <div className="notification-card-header">
        <span className={`notification-card-status-badge status-${notification.status || 'wait'}`}>
          {getStatusText(notification.status)}
        </span>
        <span className="notification-card-time">
          {formatTimeSinceCreated(notification.created_at)}
        </span>
      </div>
      <p className="notification-card-descr">{notification.notification_text}</p>
    </div>
  );
});

export default NotificationCard;
